import React from "react";
import { useNavigate } from "react-router-dom";
import "./Productrange.css";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import { createSlug } from "../../Helper/index.js";
// import das9100 from '../../assets/product/01.png';
// import das9100maize from '../../assets/product/02.png';
// import das7100 from '../../assets/product/03.png';
// import das3100 from '../../assets/product/04.png';
// import das912tdc from '../../assets/product/05.png';
// import das9124wd from '../../assets/product/05.png';
// import das731 from '../../assets/product/06.png';
// import das726 from '../../assets/product/07.png';
// import dasmaizehdr from '../../assets/product/08.png';
// import rotavator from '../../assets/product/09.png';
// import daslll from '../../assets/product/010.png';
// import dasss from '../../assets/product/011.png';
// import dassr from '../../assets/product/012.png';
// import dassb from '../../assets/product/013.png';
// import dasrb from '../../assets/product/014.png';
// import dashr from '../../assets/product/015.png';
// import dasztd from '../../assets/product/016.png';
// import dasdd from '../../assets/product/017.png';
// import daspsc from '../../assets/product/018.png';

const das9100 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275473/01_ttucqd.png";
const das9100maize =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275471/02_ihme6c.png";
const das7100 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275479/03_kmjkoe.png";
const das3100 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275480/04_ys03lq.png";
const das912tdc =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275490/05_obkzgm.png";
const das9124wd =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275490/05_obkzgm.png";
const das731 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275482/06_dobdk1.png";
const das726 =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275483/07_vjswu3.png";
const dasmaizehdr =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275469/08_jhedhl.png";
const rotavator =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275470/09_rpv1uw.png";
const daslll =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275465/010_kl81yn.png";
const dasss =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275488/011_oml9nd.png";
const dassr =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275474/012_kxc8pf.png";
const dassb =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275475/013_pwxaqp.png";
const dasrb =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275474/014_we9pwi.png";
const dashr =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275469/015_mm1osk.png";
const dasztd =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275487/016_mqpslx.png";
const dasdd =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275480/017_sxqk5a.png";
const daspsc =
  "https://res.cloudinary.com/dafd4nkgz/image/upload/v1742275466/018_iqp9ef.png";
  const das831 ="https://res.cloudinary.com/dafd4nkgz/image/upload/v1744701162/forage_harvester2_1_1_bedm6q.png";
const TestimonialSlider = () => {
  const navigate = useNavigate();

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 3,
    slidesToScroll: 1,
    initialSlide: 0,
    autoplay: true,
    autoplaySpeed: 3000,
    centerMode: true,
    centerPadding: "0",
    arrows: true,
    responsive: [
      { breakpoint: 1024, settings: { slidesToShow: 3, slidesToScroll: 1 } },
      { breakpoint: 768, settings: { slidesToShow: 2, slidesToScroll: 1 } },
      { breakpoint: 480, settings: { slidesToShow: 1, slidesToScroll: 1 } },
    ],
  };

  const productImages = {
    "Dasmesh 9100": das9100,
    "Dasmesh 9100 Maize": das9100maize,
    "Dasmesh 7100": das7100,
    "Dasmesh 3100": das3100,
    "Dasmesh 912 TDC": das912tdc,
    "Dasmesh 912 4WD": das9124wd,
    "Dasmesh 731 Track": das731,
    "Dasmesh 726 Track": das726,
    "Dasmesh Maize Header": dasmaizehdr,
    "Dasmesh 831":das831,
    "Dasmesh Rotavator": rotavator,
    "Dasmesh Laser Land Leveller": daslll,
    "Dasmesh Super Seeder": dasss,
    "Dasmesh Straw Reaper": dassr,
    "Dasmesh Square Baler": dassb,
    "Dasmesh Round Baler": dasrb,
    "Dasmesh Hey Rake": dashr,
    "Dasmesh Zero Till Drill": dasztd,
    "Dasmesh DSR Drill": dasdd,
    "Dasmesh Paddy Straw Chopper": daspsc,
  };

  const combineHarvesterProducts = [
    { id: "1", productName: "Dasmesh 9100", subCate: "Combineharvester" },
    { id: "2", productName: "Dasmesh 9100 Maize", subCate: "Combineharvester" },
    { id: "3", productName: "Dasmesh 7100", subCate: "Combineharvester" },
    { id: "4", productName: "Dasmesh 3100", subCate: "Combineharvester" },
    { id: "5", productName: "Dasmesh 912 2WD", subCate: "Combineharvester" },
    { id: "6", productName: "Dasmesh 912 4WD", subCate: "Combineharvester" },
    { id: "7", productName: "Dasmesh 731 Track", subCate: "Combineharvester" },
    { id: "8", productName: "Dasmesh 726 Track", subCate: "Combineharvester" },
    {
      id: "9",
      productName: "Dasmesh Maize Header",
      subCate: "Combineharvester",
    },
     {
      id: "20",
      productName: "Dasmesh 831",
      subCate: "Combineharvester",
    },
    { id: "10", productName: "Dasmesh Rotavator", subCate: "Rotavator" },
    {
      id: "11",
      productName: "Dasmesh Laser Land Leveller",
      subCate: "Laser Land Leveller",
    },
    { id: "12", productName: "Dasmesh Super Seeder", subCate: "superseeder" },
    { id: "13", productName: "Dasmesh Straw Reaper", subCate: "strawreaper" },
    {
      id: "19",
      productName: "Dasmesh Paddy Straw Chopper",
      subCate: "squarebaler",
    },
    { id: "14", productName: "Dasmesh Square Baler", subCate: "squarebaler" },
    { id: "15", productName: "Dasmesh Round Baler", subCate: "dsrdrill" },
    { id: "16", productName: "Dasmesh Hey Rake", subCate: "superseeder" },
    {
      id: "17",
      productName: "Dasmesh Zero Till Drill",
      subCate: "squarebaler",
    },
    { id: "18", productName: "Dasmesh DSR Drill", subCate: "squarebaler" },
   
  ];

  const handleExploreClick = (product) => {
    const slug = createSlug(product.productName || product.modeldesc);
    navigate(`/${slug}`, { state: { product } });
    window.scrollTo(0, 0);
  };

  return (
    <div className="profile-slider-container" id="product-range">
      <h3 className="slider-title">OUR PRODUCT RANGE</h3>
      <Slider {...settings}>
        {combineHarvesterProducts.map((product) => (
          <div key={product.id} className="profile-slide">
            <div className="product-card">
              <div
                className="image-box"
                onClick={() => handleExploreClick(product)}
              >
                <img
                  src={productImages[product.productName]}
                  alt={product.productName}
                  className="profile-image"
                />
              </div>
              <div
                className="product-details"
                onClick={() => handleExploreClick(product)}
              >
                <h3>{product.productName}</h3>
              </div>
            </div>
          </div>
        ))}
      </Slider>
    </div>
  );
};

export default TestimonialSlider;
